import type { MetaCatalogs, PreviewProps } from '../AppsMeta.types'

export const createPreviewProps = (
  metaCatalogId: string,
  data: MetaCatalogs,
): PreviewProps | undefined => {
  if (!metaCatalogId || !data) return

  const catalog = data.catalogs.find((catalog) => catalog.id === metaCatalogId)

  if (!catalog) return

  return {
    catalogTitle: catalog.name,
    catalogDescription: 'Facebook Product Catalog',
    catalogFooter: `ID: ${catalog.id}`,
  }
}
